import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { SalesCounterpartTypeahead } from 'components/shared/SalesCounterpartTypeahead/SalesCounterpartTypeAhead.withFilterApi';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

interface OwnProps {
  selectedOnBehalfClient: ISalesCounterpart | null;
  isDisabled?: boolean;
  isLoading: boolean;
  onChange: (newClient: ISalesCounterpart | null) => void;
}

export const SalesCounterpart: FC<OwnProps> = ({ selectedOnBehalfClient, isDisabled, isLoading, onChange }) => {
  return (
    <BlockOrientationFormGroup inputId="tradeAllocation-salescounterpart" label="tradeAllocation.edit.salesCounterpart">
      {isLoading && <SaledCounterpartTypeaheadSkeleton />}
      {!isLoading && (
        <SalesCounterpartTypeahead
          e2e="salescounterpart"
          selectedItem={selectedOnBehalfClient}
          onSelectedItemChanged={newClient => {
            onChange(newClient);
          }}
          isDisabled={isDisabled}
          hasErrors={!isDisabled && selectedOnBehalfClient === null}
        />
      )}
    </BlockOrientationFormGroup>
  );
};

const SaledCounterpartTypeaheadSkeleton: FC = () => (
  <div className="input-group input-group-md">
    <span className="input-group-text text-primary">
      <Skeleton width="1em" />
    </span>
    <div className="form-control form-control-md show">
      <Skeleton width="10em" />
    </div>
  </div>
);
